import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const jsmWorkItemPreventionCenterRoute: InvariantJiraRoute = {
	name: 'jsm-work-item-prevention-center',
	path: '/jira/servicedesk/projects/:projectKey/prevention-center/:issueKey',
	exact: true,
};
